import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const refreshQuery: DocumentNode = gql`
  mutation Refresh($refreshToken: String!, $productName: OutputRefreshProductName = Website, $challengeId: String) {
    refresh(Output_Product_Name: $productName, input: { refreshToken: $refreshToken, challengeId: $challengeId }) {
      ... on clientError {
        description
      }
      ... on refreshPayload {
        accessToken
        expiresIn
        refreshToken
      }
    }
  }
`
export default refreshQuery
